import { styled } from '@mui/joy';

import { externalQuoteTheme } from 'external-quote/styles';

export const ToolbarContainer = styled('div')({
  backgroundColor: '#F8F8F8',
  borderBottom: '1px solid #E0E0E0',
  padding: '8px 16px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

export const ActionButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '6px 12px',
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  fontSize: '15px',
  color: '#333333',
  borderRadius: '3px',
  transition: 'background-color 0.2s',
  whiteSpace: 'nowrap',

  '&:hover': {
    backgroundColor: '#E8E8E8',
  },
});

export const ButtonText = styled('span')({
  fontSize: '15px',
});

export const Divider = styled('div')({
  width: '1px',
  height: '24px',
  backgroundColor: externalQuoteTheme.colors.borderGray,
  margin: '0 8px',
});
